import React, { useEffect, useState } from 'react';
import { IEditorProps } from './props-interfaces';
import { slashTrim, withoutCaching } from 'utility';
import { config } from 'config';
import _ from 'lodash';
import { Uploader } from './uploader';

export const ImageFileEditor = (props: IEditorProps) => {
    const { path } = props;
    const [ url, setUrl ] = useState(withoutCaching(config.api.urlFromPath(path)));

    useEffect(() => {
        setUrl(withoutCaching(config.api.urlFromPath(path)));
    }, [ path ]);

    const onUpload = () => setUrl(withoutCaching(config.api.urlFromPath(path)));

    return (
        <div className="image-file-editor">
            <div className='image-file-container'>
                <div className='image-file' style={{ backgroundImage: `url(${url})` }}></div>
                <Uploader {...props} onUpload={onUpload} />
            </div>
        </div>
    );
}
